import { AppService } from './AppService';

export class RdvService{
    appService = new AppService();
    constructor(){
       
    }


    getCreneauxList(infra, refAdresse,refImmeuble) {
      const url = this.appService.getApiUrl()+'rendezvous/rendezvous.php';
      const params = {
        action: "getCreneauxList",
        infra: infra,
        refAdresse: refAdresse,
        refImmeuble:refImmeuble,
        techno: 'fibre',
        typeIntervention: 'raccordement'
      };
      return this.appService.get(url,{params})
        .then(function (response) {
            
            return response.data

        })
        .catch(function (error) {
            
            throw new Error(error);
            
        });
    }

    createIntervention(idSouscription,infra, refAdresse, refImmeuble,refRdv, dateRdv, heureDebutRdv, heureFinRdv, site, domaine) {
      const url = this.appService.getApiUrl()+'rendezvous/rendezvous.php';
      const params = {
        action: "createIntervention",
        idSouscription: idSouscription,
        infrastructure: infra,
        referenceAdresse: refAdresse,
        refImmeuble: refImmeuble,
        referenceRdv: refRdv,
        dateRdv: dateRdv,
        heureDebutRdv: heureDebutRdv,
        heureFinRdv: heureFinRdv,
        site: site,
        domaine: domaine
      };
      return this.appService.get(url,{params})
        .then(function (response) {
            
            return response.data

        })
        .catch(function (error) {
            
            throw new Error(error);
            
        });
    }

}